import {
    createContext,
    useContext
} from "react";
import type {
    RadioGroupContextType
} from "./type";

export const RadioGroupContext = createContext<RadioGroupContextType | undefined>(undefined);

export const useRadioGroupContext = (): RadioGroupContextType | undefined => {
    return useContext(RadioGroupContext);
};
